module.exports = __webpack_public_path__ + "media/img/help_center/Student_Academic_Profile_05-e99605b711983a18ede84a10beab57c5.jpg";